

export function Link(data: any) {
  return (
    <>
      <a href={data?.record?.value}/> 
    </>
  );
}